// src/components/PrivateRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "./authContext";

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        color: "white", 
        padding: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh'
      }}>
        Loading...
      </div>
    );
  }
  
  if (!currentUser) return <Navigate to="/" />;

  return children;
};

export default PrivateRoute;
